import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { GetSuppliersParams, getSuppliersCount } from '@apis/supplier';
import { dropEmptyValues } from '../../utils/common';

/**
 * useSupplierCount
 * - Fetches total supplier count for current filters
 * - IMPORTANT: queryKey must include normalized search params
 *   so that filter changes trigger refetch without requiring manual refetch or page reload.
 */
export const useSupplierCount = (searchParam: GetSuppliersParams) => {
  const normalized = dropEmptyValues(searchParam, ['supplierName', 'managerName', 'email', 'phoneNumber']);
  const searchKey = JSON.stringify(normalized ?? {});

  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['suppliersCount', searchKey],
    queryFn: () => getSuppliersCount(normalized),
    refetchOnMount: 'always',
  };

  return useQuery(queryOptions);
};
